import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import MobileDetect from 'mobile-detect';
import CaptureService from '../../../services/capture.service.js';
import html2canvas from 'html2canvas';


var CAPTURED_IMAGE_LINK_ID = 'AssuranceCapturedImageLink';

function CaptureModalVM(params) {
    var self = this;

    self.dataProvider = params.dataProvider;

    self.working = ko.observable(false);
    self.captureImageLink = ko.observable(null);
    self.captureImageDownloadName = ko.observable(null);
    self.captureImageText = ko.observable('Please wait...');

    self.md = new MobileDetect(window.navigator.userAgent);
    self.isIPhoneIpad = self.md.is('iPhone') || self.md.is('iPad');
    self.captureType = '';
    self.method = '';
    self.fileType = '';
    self.pageId = '';
    self.panelId = '';
    self.queryId = '';
}



CaptureModalVM.prototype = {
    captureImage: function (pageId, panelId) {
        var self = this,
            now = moment(),
            logDetails = panelId ? 'panel' : 'page',
            imageName = pageId + '_' + now.format('YYYYMMDD_HHmmss') + '_' + now.valueOf();

        self.dataProvider.logActivity2('capturingImage', '', logDetails, {pageId: pageId, panelId: panelId});

        self.working(true);
        self.captureImageLink(null);
        self.captureImageText('Please wait...');

        var source = panelId
            ? $('#' + panelId)
            : $('.wrapper');

        let bg = getComputedStyle(source.get(0)).getPropertyValue('--background-color');

        html2canvas(source[0], {
            allowTaint: true,
            useCORS: true,
            backgroundColor: bg,
        }).then(function (canvas) {
            var linkEl = _.first($('#' + CAPTURED_IMAGE_LINK_ID));
            var imageNameWithExtension = imageName + '.png';

            canvas.toBlob(blob => {
                if (typeof linkEl.download === 'undefined' && window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, imageNameWithExtension);
                } else {
                    self.working(false);
                    self.captureImageDownloadName(imageNameWithExtension);

                    var url = window.URL.createObjectURL(blob);
                    self.captureImageLink(url);
                    self.captureImageText('Click to download');

                    linkEl.click();
                    window.URL.revokeObjectURL(url);
                }
                if (!self.isIPhoneIpad) {
                    _.first($('#AssuranceCaptureModal #modalclose')).click();
                }
                self.removeCanvas(source);
            });
        });
    },

    execute: function () {
        var self = this;
        self.captureImage(self.pageId, self.panelId);
    },

    initialize: function (captureType, pageId, panelId) {
        var self = this;
        self.captureType = captureType;
        self.pageId = pageId;
        self.panelId = panelId;
        self.queryId = pageId;

        self.working(true);
        self.captureImageDownloadName(null);
        self.captureImageLink(null);
        self.captureImageText('Please wait...');
    },

    removeCanvas: function (context) {
        context.find('.screenShotTempCanvas').remove();
        context.find('.svgCaptureTempHide').show();
        context.find('.svgCaptureTempHide').each(function () {
            $(this).attr('class', $(this).attr('class').replace('svgCaptureTempHide', '').trim());
        });
    }
};

export default CaptureModalVM;
